import type { PropType } from 'vue';
import { type ComponentSizes } from '../../constants';

export interface IconProps {
    size?: ComponentSizes,
    color?: string,
}

export const iconProps = {
    size: {
        type: String as PropType<IconProps['size']>,
        default: undefined,
        required: false,
    },
    color: {
        type: String as PropType<IconProps['color']>,
        default: undefined,
        required: false,
    },
};
